// eslint-disable-next-line import/no-anonymous-default-export
export default {
    formId: "new-cooperated-form",
    formField: {
      // messages
      message: {
        name: "message",
        label: "Mensagem",
        type: "text",
      },
      // datas
      fullName: {
        name: "fullName",
        label: "Nome Completo",
        type: "text",
        errorMsg: "O nome completo é obrigatório",
        invalidMsg: "Nome completo inválido",
      },
      socialName: {
        name: "socialName",
        label: "Nome Social",
        type: "text",
        errorMsg: "O nome social é obrigatório",
        invalidMsg: "Nome social inválido",
      },
      CPF: {
        name: "CPF",
        label: "CPF",
        type: "text",
        mask: "CPF",
        errorMsg: "O CPF é obrigatório",
        invalidMsg: "CPF inválido",
      },
      birthDate: {
        name: "birthDate",
        label: "Data de Nascimento",
        type: "text",
        mask: "date",
        errorMsg: "A data de nascimento é obrigatório",
        invalidMsg: "Data de nascimento inválida",
      },
      sex: {
        name: "sex",
        label: "Sexo",
        type: "text",
        errorMsg: "O sexo é obrigatório",
        invalidMsg: "Sexo inválido",
      },
      PA: {
        name: "pa",
        label: "PA",
        type: "text",
        errorMsg: "O PA é obrigatório",
        invalidMsg: "PA inválido",
      },
      documentType: {
        name: "documentType",
        label: "Tipo de Documento",
        type: "text",
        errorMsg: "O tipo de documento é obrigatório",
        invalidMsg: "Tipo de documento inválido",
      },
      documentNumber: {
        name: "documentNumber",
        label: "Número do Documento",
        type: "text",
        errorMsg: "O número do documento é obrigatório",
        invalidMsg: "Número do documento inválido",
      },
      issuingAgency: {
        name: "issuingAgency",
        label: "Órgão Emissor",
        type: "text",
        errorMsg: "O órgão emissor é obrigatório",
        invalidMsg: "Órgão emissor inválido",
      },
      FUData: {
        name: "FUData",
        label: "UF",
        type: "text",
        errorMsg: "O UF é obrigatório",
        invalidMsg: "UF inválido",
      },
      issueDate: {
        name: "issueDate",
        label: "Data de Emissão",
        type: "text",
        mask: "date",
        errorMsg: "A data de emissão é obrigatória",
        invalidMsg: "Data de emissão inválida",
      },
      nationality: {
        name: "nationality",
        label: "Nacionalidade",
        type: "text",
        errorMsg: "A nacionalidade é obrigatória",
        invalidMsg: "Nacionalidade inválida",
      },
      birthCity: {
        name: "birthCity",
        label: "Cidade de Nascimento",
        type: "text",
        errorMsg: "A cidade de nascimento é obrigatória",
        invalidMsg: "Cidade de nascimento inválida",
      },
      birthFU: {
        name: "birthFU",
        label: "UF de Nascimento",
        type: "text",
        errorMsg: "O UF de nascimento é obrigatório",
        invalidMsg: "UF de nascimento inválido",
      },
      motherName: {
        name: "motherName",
        label: "Nome da Mãe",
        type: "text",
        errorMsg: "O nome da mãe é obrigatório",
        invalidMsg: "Nome da mãe inválido",
      },
      fatherName: {
        name: "fatherName",
        label: "Nome do Pai",
        type: "text",
        errorMsg: "O nome do pai é obrigatório",
        invalidMsg: "Nome do pai inválido",
      },
      // contacts
      email: {
        name: "email",
        label: "Email",
        type: "email",
        errorMsg: "O email é obrigatório",
        invalidMsg: "email inválido",
      },
      phone: {
        name: "phone",
        label: "Celular",
        type: "text",
        mask: "phoneBR",
        errorMsg: "O celular é obrigatório",
        invalidMsg: "Celular inválido",
      },
      formOfContact: {
        name: "formOfContact",
        label: "Forma de Contato",
        type: "text",
        errorMsg: "A forma de contato é obrigatória",
        invalidMsg: "Forma de contato inválida",
      },
      contact: {
        name: "contact",
        label: "Contato",
        type: "text",
        errorMsg: "O contato é obrigatório",
        invalidMsg: "Contato inválido",
      },
      // address
      CEP: {
        name: "CEP",
        label: "CEP",
        type: "text",
        mask: "CEP",
        errorMsg: "O CEP é obrigatório",
        invalidMsg: "CEP inválido",
      },
      street: {
        name: "street",
        label: "Rua",
        type: "text",
        errorMsg: "A rua é obrigatória",
        invalidMsg: "Rua inválida",
      },
      number: {
        name: "number",
        label: "Número",
        type: "text",
        errorMsg: "O número é obrigatório",
        invalidMsg: "Número inválido",
      },
      complements: {
        name: "complements",
        label: "Complementos",
        type: "text",
        errorMsg: "O complemento é obrigatório",
        invalidMsg: "Complemento inválido",
      },
      FUAddress: {
        name: "FUAddress",
        label: "UF",
        type: "text",
        errorMsg: "O UF é obrigatório",
        invalidMsg: "UF inválido",
      },
      district: {
        name: "district",
        label: "Bairro",
        type: "text",
        errorMsg: "O bairro é obrigatório",
        invalidMsg: "Bairro inválido",
      },
      city: {
        name: "city",
        label: "Cidade",
        type: "text",
        errorMsg: "A cidade é obrigatória",
        invalidMsg: "Cidade inválida",
      },
      mailingAddress: {
        name: "mailingAddress",
        label: "Endereço de Correspondência",
        type: "text",
        errorMsg: "O endereço de correspondência é obrigatório",
        invalidMsg: "Endereço de correspondência inválido",
      },
      // complements
      income: {
        name: "income",
        label: "Renda",
        type: "text",
        errorMsg: "A renda é obrigatória",
        invalidMsg: "Renda inválida",
      },
      // descriptions
      privateDescription: {
        name: "privateDescription",
        label: "Descrição Privada",
        type: "text",
        invalidMsg: "Descrição privada inválida",
      },
      accountNumber: {
        name: "accountNumber",
        label: "Número da Conta",
        type: "text",
      },
      situationDocument: {
        name: "situationDocument",
        label: "Situação CPF",
        type: "text",
      },
      reasonReprovation: {
        name: "reasonReprovation",
        label: "Motivo da reprovação",
        type: "text",
      },
      // documents
    },
  };